import { EPricingVariations } from './Pricing.types';
import PricingCards from './variations/PricingCards';
import PricingCardDynamic from './variations/PricingCardDynamic';

const Marquee = ({ slice }) => {
  switch (slice.variation) {
    case EPricingVariations.pricingCards:
      return <PricingCards slice={slice} />;
    case EPricingVariations.pricingCardDynamic:
      return <PricingCardDynamic slice={slice} />;
    default:
      return null;
  }
};

export default Marquee;
